import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import GodMemberPage from './pages/GodMemberPage';
import SBFNeedReviewPage from './pages/SBFNeedReviewPage';
import GodGroupPage from './pages/GodGroupPage';
import GodAutoBotPage from './pages/GodAutoBotPage';
import GodReviewPage from './pages/GodReviewPage';
import GodNonMemberPage from './pages/GodNonMemberPage';
import GodConsumerPage from './pages/GodConsumerPage';
import SLGWebConfigPage from './pages/SLGWebConfigPage';
import SLGAnalyticsPage from './pages/SLGAnalyticsPage';
import ReviewWebAnalyticsPage from './pages/ReviewWebAnalyticsPage';
import RedirectAnalyticsPage from './pages/RedirectAnalyticsPage';
import UnblockAnalyticsPage from './pages/UnblockAnalyticsPage';
import WatchAnalyticsPage from './pages/WatchAnalyticsPage';
import SimonAnalyticsPage from './pages/SimonAnalyticsPage';
import AdsAnalyticsPage from './pages/AdsAnalyticsPage';
import AnalyticsHubPage from './pages/AnalyticsHubPage';
import PaymentPage from './pages/PaymentPage';
import ExpiringMemberPage from './pages/ExpiringMemberPage';
import ShopPage from './pages/ShopPage';
import CommandPage from './pages/CommandPage';
import SBFDashboard from './pages/SBFDashboard';
import SBFMemberPage from './pages/SBFMemberPage';
import SBFPaymentPage from './pages/SBFPaymentPage';
import UnblockDashboard from './pages/UnblockDashboard';
import RedirectDashboard from './pages/RedirectDashboard';
import RedirectDomainsPage from './pages/RedirectDomainsPage';
import RedirectGroupsPage from './pages/RedirectGroupsPage';
import RedirectHelpPage from './pages/RedirectHelpPage';
import UnblockMemberPage from './pages/UnblockMemberPage';
import UnblockPaymentPage from './pages/UnblockPaymentPage';
import UnblockWebConfigPage from './pages/UnblockWebConfigPage';
import UnblockTGConfigPage from './pages/UnblockTGConfigPage';
import FODashboard from './pages/FODashboard';
import FOCustomerPage from './pages/FOCustomerPage';
import FOProductPage from './pages/FOProductPage';
import FOOrderPage from './pages/FOOrderPage';
import MainDashboard from './pages/MainDashboard';
import AssetPage from './pages/AssetPage';
import SFRTDashboard from './pages/SFRTDashboard';
import SFRTPaymentPage from './pages/SFRTPaymentPage';
import SimonReceivablePage from './pages/SimonReceivablePage';
import SimonDashboard from './pages/SimonDashboard';
import SimonCustomerPage from './pages/SimonCustomerPage';
import SimonProductPage from './pages/SimonProductPage';
import SimonBundlePage from './pages/SimonBundlePage';
import SimonOrderPage from './pages/SimonOrderPage';
import SimonConfigPage from './pages/SimonConfigPage';
import AdsDashboard from './pages/AdsDashboard';
import AdsPage from './pages/AdsPage';
import SupermanDashboard from './pages/SupermanDashboard';
import SupermanMemberPage from './pages/SupermanMemberPage';
import SupermanPaymentPage from './pages/SupermanPaymentPage';
import SupermanArmyPage from './pages/SupermanArmyPage';
import SupermanReviewPage from './pages/SupermanReviewPage';
import RecentDeletesPage from './pages/RecentDeletesPage';
import ErpAuditLogPage from './pages/ErpAuditLogPage';
import ExchangeRatesPage from './pages/ExchangeRatesPage';
import ProtectedRoute from './components/ProtectedRoute';
import NotFoundPage from './pages/NotFoundPage';

/** Old /fo/* bookmarks → /gz/* */
function FoToGzRedirect() {
    const location = useLocation();
    const to = `${location.pathname.replace(/^\/fo/, '/gz')}${location.search}${location.hash}`;
    return <Navigate to={to} replace />;
}

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/login" element={<Login />} />
                
                {/* Main Dashboard Route */}
                <Route 
                    path="/main-dashboard" 
                    element={
                        <ProtectedRoute>
                            <MainDashboard />
                        </ProtectedRoute>
                    } 
                />
                <Route
                    path="/main-dashboard/recent-deletes"
                    element={
                        <ProtectedRoute>
                            <RecentDeletesPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/main-dashboard/audit-log"
                    element={
                        <ProtectedRoute>
                            <ErpAuditLogPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/exchange-rates"
                    element={
                        <ProtectedRoute>
                            <ExchangeRatesPage />
                        </ProtectedRoute>
                    }
                />
                <Route 
                    path="/assets" 
                    element={<Navigate to="/assets/domains" replace />} 
                />
                <Route
                    path="/assets/RecentDelete"
                    element={
                        <ProtectedRoute>
                            <RecentDeletesPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/assets/audit-log"
                    element={
                        <ProtectedRoute>
                            <ErpAuditLogPage />
                        </ProtectedRoute>
                    }
                />
                <Route 
                    path="/assets/:tab" 
                    element={
                        <ProtectedRoute>
                            <AssetPage />
                        </ProtectedRoute>
                    } 
                />
                
                {/* SBF Routes */}
                <Route 
                    path="/sbf/dashboard" 
                    element={
                        <ProtectedRoute>
                            <SBFDashboard />
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/sbf/sbf-members" 
                    element={
                        <ProtectedRoute>
                            <SBFMemberPage />
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/sbf/sbf-payment" 
                    element={
                        <ProtectedRoute>
                            <SBFPaymentPage />
                        </ProtectedRoute>
                    } 
                />
                
                {/* UNBLOCK Routes */}
                <Route 
                    path="/unblock/dashboard" 
                    element={
                        <ProtectedRoute>
                            <UnblockDashboard />
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/unblock/unblock-members" 
                    element={
                        <ProtectedRoute>
                            <UnblockMemberPage />
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/unblock/unblock-payments" 
                    element={
                        <ProtectedRoute>
                            <UnblockPaymentPage />
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/unblock/web-config" 
                    element={
                        <ProtectedRoute>
                            <UnblockWebConfigPage />
                        </ProtectedRoute>
                    } 
                />
                <Route
                    path="/unblock/tg-config"
                    element={
                        <ProtectedRoute>
                            <UnblockTGConfigPage />
                        </ProtectedRoute>
                    }
                />
                
                {/* REDIRECT Routes */}
                <Route
                    path="/redirect/dashboard"
                    element={
                        <ProtectedRoute>
                            <RedirectDashboard />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/redirect/domains"
                    element={
                        <ProtectedRoute>
                            <RedirectDomainsPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/redirect/groups"
                    element={
                        <ProtectedRoute>
                            <RedirectGroupsPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/redirect/help"
                    element={
                        <ProtectedRoute>
                            <RedirectHelpPage />
                        </ProtectedRoute>
                    }
                />
                
                {/* GZ Routes (formerly FO) */}
                <Route 
                    path="/gz/dashboard" 
                    element={
                        <ProtectedRoute>
                            <FODashboard />
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/gz/customer" 
                    element={
                        <ProtectedRoute>
                            <FOCustomerPage />
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/gz/products" 
                    element={
                        <ProtectedRoute>
                            <FOProductPage />
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/gz/orders" 
                    element={
                        <ProtectedRoute>
                            <FOOrderPage />
                        </ProtectedRoute>
                    } 
                />
                <Route path="/fo/*" element={<FoToGzRedirect />} />
                
                {/* SFRT Routes */}
                <Route 
                    path="/sfrt/dashboard" 
                    element={
                        <ProtectedRoute>
                            <SFRTDashboard />
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/sfrt/payment" 
                    element={
                        <ProtectedRoute>
                            <SFRTPaymentPage />
                        </ProtectedRoute>
                    } 
                />
                
                {/* Ads Routes */}
                <Route
                    path="/ads/dashboard"
                    element={
                        <ProtectedRoute>
                            <AdsDashboard />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/ads/list"
                    element={
                        <ProtectedRoute>
                            <AdsPage />
                        </ProtectedRoute>
                    }
                />
                <Route path="/ads" element={<Navigate to="/ads/dashboard" replace />} />

                {/* Superman Routes */}
                <Route
                    path="/superman/dashboard"
                    element={
                        <ProtectedRoute>
                            <SupermanDashboard />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/superman/members"
                    element={
                        <ProtectedRoute>
                            <SupermanMemberPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/superman/payments"
                    element={
                        <ProtectedRoute>
                            <SupermanPaymentPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/superman/army"
                    element={
                        <ProtectedRoute>
                            <SupermanArmyPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/superman/reviews"
                    element={
                        <ProtectedRoute>
                            <SupermanReviewPage />
                        </ProtectedRoute>
                    }
                />
                <Route path="/superman" element={<Navigate to="/superman/dashboard" replace />} />

                {/* Simon Routes */}
                <Route 
                    path="/simon/dashboard" 
                    element={
                        <ProtectedRoute>
                            <SimonDashboard />
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/simon/receivable" 
                    element={
                        <ProtectedRoute>
                            <SimonReceivablePage />
                        </ProtectedRoute>
                    } 
                />
                <Route
                    path="/simon/customers"
                    element={
                        <ProtectedRoute>
                            <SimonCustomerPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/simon/products"
                    element={
                        <ProtectedRoute>
                            <SimonProductPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/simon/bundle"
                    element={
                        <ProtectedRoute>
                            <SimonBundlePage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/simon/order"
                    element={
                        <ProtectedRoute>
                            <SimonOrderPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/simon/config"
                    element={
                        <ProtectedRoute>
                            <SimonConfigPage />
                        </ProtectedRoute>
                    }
                />
                
                {/* GOD Routes */}
                <Route 
                    path="/god/dashboard" 
                    element={
                        <ProtectedRoute>
                            <Dashboard />
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/god/god-members" 
                    element={
                        <ProtectedRoute>
                            <GodMemberPage />
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/god/sbfNeedReview" 
                    element={
                        <ProtectedRoute>
                            <SBFNeedReviewPage />
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/god/god-groups" 
                    element={
                        <ProtectedRoute>
                            <GodGroupPage />
                        </ProtectedRoute>
                    } 
                />
                <Route
                    path="/god/autobot"
                    element={
                        <ProtectedRoute>
                            <GodAutoBotPage />
                        </ProtectedRoute>
                    }
                />
                <Route 
                    path="/god/expiring-members" 
                    element={
                        <ProtectedRoute>
                            <ExpiringMemberPage />
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/god/payments" 
                    element={
                        <ProtectedRoute>
                            <PaymentPage />
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/god/shops" 
                    element={
                        <ProtectedRoute>
                            <ShopPage />
                        </ProtectedRoute>
                    } 
                />
                <Route 
                    path="/god/reviewPage" 
                    element={
                        <ProtectedRoute>
                            <GodReviewPage />
                        </ProtectedRoute>
                    } 
                />
                <Route
                    path="/god/non-members"
                    element={
                        <ProtectedRoute>
                            <GodNonMemberPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/god/consumers"
                    element={
                        <ProtectedRoute>
                            <GodConsumerPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/god/slgwebconfig"
                    element={
                        <ProtectedRoute>
                            <SLGWebConfigPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/analytics"
                    element={
                        <ProtectedRoute>
                            <AnalyticsHubPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/analytics/slgweb"
                    element={
                        <ProtectedRoute>
                            <SLGAnalyticsPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/analytics/reviewweb"
                    element={
                        <ProtectedRoute>
                            <ReviewWebAnalyticsPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/analytics/redirect"
                    element={
                        <ProtectedRoute>
                            <RedirectAnalyticsPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/analytics/unblock"
                    element={
                        <ProtectedRoute>
                            <UnblockAnalyticsPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/analytics/watch"
                    element={
                        <ProtectedRoute>
                            <WatchAnalyticsPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/analytics/simon"
                    element={
                        <ProtectedRoute>
                            <SimonAnalyticsPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/analytics/ads"
                    element={
                        <ProtectedRoute>
                            <AdsAnalyticsPage />
                        </ProtectedRoute>
                    }
                />
                <Route path="/god/analytics" element={<Navigate to="/analytics/slgweb" replace />} />
                <Route path="/god/review-web-analytics" element={<Navigate to="/analytics/reviewweb" replace />} />
                <Route 
                    path="/god/commands" 
                    element={
                        <ProtectedRoute>
                            <CommandPage />
                        </ProtectedRoute>
                    } 
                />
                <Route
                    path="/god/audit-log"
                    element={
                        <ProtectedRoute>
                            <ErpAuditLogPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/:section/audit-log"
                    element={
                        <ProtectedRoute>
                            <ErpAuditLogPage />
                        </ProtectedRoute>
                    }
                />
                <Route path="/main/asset" element={<Navigate to="/assets/domains" replace />} />
                <Route path="/" element={<Navigate to="/main-dashboard" replace />} />
                {/* Per-project trash (must be after specific section routes) */}
                <Route
                    path="/:section/RecentDelete"
                    element={
                        <ProtectedRoute>
                            <RecentDeletesPage />
                        </ProtectedRoute>
                    }
                />
                <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </Router>
    );
}

export default App; 